// extracted by mini-css-extract-plugin
export default {"formGroup":"Select_formGroup__hAaG8","mandatory":"Select_mandatory__wH+zb"};